import getRequest from '../../../../requests/getRequest';

export const getUpdatedRequest = async (requestId) => {
  const requestArr = await getRequest(
    requestId,
    'Не удалось получить обновленную заявку. Обновите страницу, чтобы увидеть изменения'
  );

  return Array.isArray(requestArr) && requestArr.length > 0
    ? requestArr[0]
    : null;
};
